module.exports = __webpack_public_path__ + "static/bas_outside-1cf0033964eaa25dc4ac2aa92787da38.jpg";